// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.scl--cms-pages-notificationPage {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 76px);
  min-height: 0;
  padding: 10px 130px;
  box-sizing: border-box;
}

/* ─── Title ─────────────────────────────────────────────────────────────────── */

.scl--cms-pages-notificationPage-title {
  margin: 0 0 5px 0;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 40px;
  color: #323539;
}

/* ─── Description ───────────────────────────────────────────────────────────── */

.scl--cms-pages-notificationPage-description {
  margin: 0 0 16px 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: #8a8b8f;
  max-width: 1168px;
}

/* ─── Tab Bar ───────────────────────────────────────────────────────────────── */

.scl--cms-pages-notificationPage-tabBar {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid var(--Neutralcolors-400, #E1E4ED);
  margin-bottom: 24px;
}

.scl--cms-pages-notificationPage-tabBtn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  position: relative;
  padding-bottom: 0px;
}

.scl--cms-pages-notificationPage-tabLabel {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  line-height: 22px;
  transition: color 0.2s;
  padding-bottom: 8px;
}

.scl--cms-pages-notificationPage-tabLabel--active {
  color: #2388ff;
  font-weight: 500;
}

.scl--cms-pages-notificationPage-tabLabel--inactive {
  color: #8a8b8f;
  font-weight: 400;
  transition: all 0.3s ease;
}

.scl--cms-pages-notificationPage-tabIndicator {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #2388ff;
  border-radius: 2px;
}

/* ─── Content Area ──────────────────────────────────────────────────────────── */

.scl--cms-pages-notificationPage-content {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.scl--cms-pages-notificationPage-content::-webkit-scrollbar {
  display: none;  
}

.scl--cms-pages-notificationPage-content svg{
  width: 13px;
  height: 13px;
}

.scl--cms-pages-notificationPage-content svg path{
  stroke: white;
  stroke-width: 2px;
}

/* ─── Notification Row ──────────────────────────────────────────────────────── */


.scl--cms-pages-notificationPage-row {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px;
  gap: 12px;
  width: 100%;
  border-bottom: 1px solid #f2f4f7;
  position: relative;
  isolation: isolate;
  transition: all 0.3s ease;
  min-width: 0;
}

.scl--cms-pages-notificationPage-row:hover {
  background: #EFF3F880;
}

/* ─── Avatar ────────────────────────────────────────────────────────────────── */

.scl--cms-pages-notificationPage-avatar {
  width: 32px;
  height: 32px;
  border-radius: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scl--cms-pages-notificationPage-avatar--green {
  background: #41cc57;
}

.scl--cms-pages-notificationPage-avatar--blue {
  background: #2388ff;
}

.scl--cms-pages-notificationPage-avatar--red {
  background: #fe566b;
}

/* ─── Row Content ───────────────────────────────────────────────────────────── */

.scl--cms-pages-notificationPage-rowContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2px 0px;
  gap: 16px;
  flex: 1;
  min-width: 0;
  /* prevents flex child from overflowing */
}

.scl--cms-pages-notificationPage-rowText {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.scl--cms-pages-notificationPage-rowTitle {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #111927;
  overflow-wrap: break-word;
  word-break: break-word;
  cursor: pointer;
}

.scl--cms-pages-notificationPage-rowTitle::first-letter {
  text-transform: uppercase;
}

.scl--cms-pages-notificationPage-rowTitle:hover {
  text-decoration: underline;
}

.scl--cms-pages-notificationPage-rowBody {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: #111927;
  width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
}

.scl--cms-pages-notificationPage-rowTime {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #6c727e;
  width: 100%;
}

/* ─── Three-dot Menu Button ─────────────────────────────────────────────────── */

.scl--cms-pages-notificationPage-menuBtn {
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #6c727e;
  border-radius: 6px;
  transition: background 0.15s;
}

.scl--cms-pages-notificationPage-menuBtn:hover {
  background: rgba(255, 255, 255, 0.06);
}

.scl--cms-pages-notificationPage .notification-section {
  min-height: 100px;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/notification/css/notificationPage.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,kFAAkF;;AAElF;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kFAAkF;;AAElF;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA,kFAAkF;;AAElF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,kFAAkF;;AAElF;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,kFAAkF;;;AAGlF;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kFAAkF;;AAElF;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kFAAkF;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,kFAAkF;;AAElF;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":["\n.scl--cms-pages-notificationPage {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 76px);\n  min-height: 0;\n  padding: 10px 130px;\n  box-sizing: border-box;\n}\n\n/* ─── Title ─────────────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-notificationPage-title {\n  margin: 0 0 5px 0;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 40px;\n  color: #323539;\n}\n\n/* ─── Description ───────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-notificationPage-description {\n  margin: 0 0 16px 0;\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.01em;\n  color: #8a8b8f;\n  max-width: 1168px;\n}\n\n/* ─── Tab Bar ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-notificationPage-tabBar {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 30px;\n  width: 100%;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--Neutralcolors-400, #E1E4ED);\n  margin-bottom: 24px;\n}\n\n.scl--cms-pages-notificationPage-tabBtn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  position: relative;\n  padding-bottom: 0px;\n}\n\n.scl--cms-pages-notificationPage-tabLabel {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  transition: color 0.2s;\n  padding-bottom: 8px;\n}\n\n.scl--cms-pages-notificationPage-tabLabel--active {\n  color: #2388ff;\n  font-weight: 500;\n}\n\n.scl--cms-pages-notificationPage-tabLabel--inactive {\n  color: #8a8b8f;\n  font-weight: 400;\n  transition: all 0.3s ease;\n}\n\n.scl--cms-pages-notificationPage-tabIndicator {\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #2388ff;\n  border-radius: 2px;\n}\n\n/* ─── Content Area ──────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-notificationPage-content {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.scl--cms-pages-notificationPage-content::-webkit-scrollbar {\n  display: none;  \n}\n\n.scl--cms-pages-notificationPage-content svg{\n  width: 13px;\n  height: 13px;\n}\n\n.scl--cms-pages-notificationPage-content svg path{\n  stroke: white;\n  stroke-width: 2px;\n}\n\n/* ─── Notification Row ──────────────────────────────────────────────────────── */\n\n\n.scl--cms-pages-notificationPage-row {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 16px;\n  gap: 12px;\n  width: 100%;\n  border-bottom: 1px solid #f2f4f7;\n  position: relative;\n  isolation: isolate;\n  transition: all 0.3s ease;\n  min-width: 0;\n}\n\n.scl--cms-pages-notificationPage-row:hover {\n  background: #EFF3F880;\n}\n\n/* ─── Avatar ────────────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-notificationPage-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 20px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scl--cms-pages-notificationPage-avatar--green {\n  background: #41cc57;\n}\n\n.scl--cms-pages-notificationPage-avatar--blue {\n  background: #2388ff;\n}\n\n.scl--cms-pages-notificationPage-avatar--red {\n  background: #fe566b;\n}\n\n/* ─── Row Content ───────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-notificationPage-rowContent {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 2px 0px;\n  gap: 16px;\n  flex: 1;\n  min-width: 0;\n  /* prevents flex child from overflowing */\n}\n\n.scl--cms-pages-notificationPage-rowText {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n  min-width: 0;\n}\n\n.scl--cms-pages-notificationPage-rowTitle {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #111927;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  cursor: pointer;\n}\n\n.scl--cms-pages-notificationPage-rowTitle::first-letter {\n  text-transform: uppercase;\n}\n\n.scl--cms-pages-notificationPage-rowTitle:hover {\n  text-decoration: underline;\n}\n\n.scl--cms-pages-notificationPage-rowBody {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 143%;\n  letter-spacing: 0.17px;\n  color: #111927;\n  width: 100%;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.scl--cms-pages-notificationPage-rowTime {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #6c727e;\n  width: 100%;\n}\n\n/* ─── Three-dot Menu Button ─────────────────────────────────────────────────── */\n\n.scl--cms-pages-notificationPage-menuBtn {\n  width: 36px;\n  height: 36px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #6c727e;\n  border-radius: 6px;\n  transition: background 0.15s;\n}\n\n.scl--cms-pages-notificationPage-menuBtn:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.scl--cms-pages-notificationPage .notification-section {\n  min-height: 100px;\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
